module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid6_1080x841.7c3adec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid6_1080x841.jpg
// module id = 5Oki
// module chunks = 0